module.exports = __webpack_public_path__ + "img/tagbutton.670d7a0a.png";